import React from 'react'

interface AuthButtonProps {
  children: React.ReactNode
  type?: 'button' | 'submit'
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  loading?: boolean
  disabled?: boolean
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
  icon?: React.ReactNode
  'data-testid'?: string
}

export function AuthButton({
  children,
  type = 'button',
  variant = 'primary',
  loading = false,
  disabled = false,
  onClick,
  className = '',
  icon,
  'data-testid': dataTestId
}: AuthButtonProps) {
  const getVariantClasses = () => {
    switch (variant) {
      case 'primary':
        return 'btn-primary'
      case 'secondary':
        return 'btn-secondary'
      case 'ghost':
        return 'btn-ghost'
      case 'danger':
        return 'btn-danger'
      default:
        return 'btn-primary'
    }
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${getVariantClasses()}
        ${className}
      `}
      data-testid={dataTestId}
    >
      {loading && (
        <div
          className="animate-spin rounded-full h-4 w-4 border-2 border-current border-t-transparent"
          data-testid={dataTestId ? `${dataTestId}-loader` : undefined}
        />
      )}
      {!loading && icon && icon}
      {children}
    </button>
  )
}